import { createTheme } from "@mui/material/styles";

const getTheme = (direction = "ltr", mode = "light") =>
  createTheme({
    direction,
    palette: {
      mode,
      ...(mode === "light"
        ? {
            // palette values for light mode
            primary: {
              main: "#fcded3",
            },
            background: {
              default: "#fef5f2",
              statistics: "#ffffff",
              steps: "#ead2d4",
              stepsBorder: "#D8C7FF",
              reviews: "#f4f2fa",
              reviewCard: "#fff",
              faq: "#E6E6E6",
              planeHeader: "#fcded3",
              planeHeaderBorder: "#fff",
              planeColumn: "#fcded3",
              contactField: "#ffffffc9",
              footer: "#f9ddde",
              footerBorder: "#ddd",
              footerBottom: "#fff",
              footerDivider: "#f5c8ca",
              footerLinks: "#666",
              dialog: "linear-gradient(-45deg, #ead2d4, #ead2d4cd)",
              header: "#F8C2B0",
              buttonHeader: "#DD3740",
              buttonHeaderHover: "#e5aeb4",
              globalButton: "#000",
              globalButtonHover: "#252525ff",
              pricingBg: "#fefefe",
            },
            secondary: {
              main: "#f50057",
            },
            text: {
              primary: "#000",
              secondary: "#424242",
              third: "#fff",
            },
          }
        : {
            // palette values for dark mode
            primary: {
              main: "#fcded3",
            },
            secondary: {
              main: "#f50057",
            },
            background: {
              default: "#121212",
              statistics: "#1e1e1e",
              steps: "rgb(43, 41, 43)",
              stepsBorder: "#58565C",
              reviews: "rgba(64, 64, 64, 0.43)",
              reviewCard: "#000",
              faq: "rgb(21, 21, 21)",
              planeHeader: "#24262b",
              planeHeaderBorder: "#ffffffff",
              planeColumn: "#24262b",
              contactField: "#6a6a6acf",
              footer: "#464646cc",
              footerBorder: "#ddd",
              footerBottom: "#00000054",
              footerDivider: "#ffffffff",
              footerLinks: "#a6a6a6",
              dialog: "linear-gradient(-45deg, #181212, #686666ff);",
              paper: "#121212",
              header: "#1a1a1aff",
              buttonHeader: "#DD3740",
              buttonHeaderHover: "#e5aeb4",
              globalButton: "#fff",
              globalButtonHover: "#e0e0e0ff",
              pricingBg: "#000000",
            },
            text: {
              primary: "#fff",
              secondary: "#bdbdbd",
              third: "#000",
            },
          }),
    },
    typography: {
      fontFamily: "Tajawal",
      htmlFontSize: 16,
      fontWeightExtraLight: 100,
      fontWeightLight: 200,
      fontWeightRegular: 400,
      fontWeightMedium: 300,
      fontWeightExtraBold: 600,
      fontWeightBold: 500,
      fontWeightBlack: 700,
      h1: {
        fontWeight: 700,
        fontSize: "3.375rem",
        lineHeight: 1.21,
      },
      h2: {
        fontWeight: 600,
        fontSize: "1.875rem",
        lineHeight: 1.27,
      },
      h3: {
        fontWeight: 500,
        fontSize: "1.5rem",
        lineHeight: 1.33,
      },
      h4: {
        fontWeight: 400,
        fontSize: "1.25rem",
        lineHeight: 1.4,
      },
      h5: {
        fontWeight: 300,
        fontSize: "1rem",
        lineHeight: 1.5,
      },
      h6: {
        fontWeight: 200,
        fontSize: "0.875rem",
        lineHeight: 1.57,
      },
      h7: {
        fontWeight: 100,
        fontSize: "0.875rem",
        lineHeight: 1.57,
      },
      caption: {
        fontWeight: 400,
        fontSize: "0.75rem",
        lineHeight: 1.66,
      },
      body1: {
        fontSize: "0.875rem",
        lineHeight: 1.57,
      },
      body2: {
        fontSize: "0.75rem",
        lineHeight: 1.66,
      },
      subtitle1: {
        fontSize: "0.875rem",
        fontWeight: 600,
        lineHeight: 1.57,
      },
      subtitle2: {
        fontSize: "0.75rem",
        fontWeight: 500,
        lineHeight: 1.66,
      },
      overline: {
        lineHeight: 1.66,
      },
      button: {
        textTransform: "capitalize",
      },
    },
  });

export default getTheme;
